import Image from 'next/image';
import { StylesConfig } from 'react-select';
import { MenuItem } from './types/header';
import { WinDataType } from './types/window';
export const PAGE_SIZE = 50;
export const HTTP_OK = 200;
export const HTTP_OK_2 = 201;
export const UNAUTHORIZED_STATUS = 401;
export const MIN_3 = 3;
export const MAX_500 = 500;
export const MAX_30 = 30;
export const MAX_38 = 38;
export const MAX_160 = 160;
export const MAX_25 = 25;
export const MAX_10 = 10;
export const MAX_256 = 256;
export const MAX_255 = 255;
export const MAX_75 = 75;
export const MAX_45 = 45;
export const MAX_11 = 11;
export const MAX_5 = 5;
export const MAX_21 = 21;
export const MAX_99 = 99;
export const MAX_ASSET_SEARCH_TEXT = 3;
export const DEBOUNCE_DELAY = 500;
export const MOBILE_VIEW_BREAKPOINT = 1199;
export const SOCKET_RETRY_DELAY = 2000;
export const ACCESS_TOKEN_KEY = 'access-token';
export const SECONDS_IN_AN_HOUR = 3600;
export const ACCESS_TOKEN_LIFETIME_HOURS = 3;
export const UPDATE_SESSION_LIFETIME_HOURS = 12;
export const MAXAGE_SESSION_LIFETIME_HOURS = 24;
export const ACCESS_TOKEN_MAX_AGE = ACCESS_TOKEN_LIFETIME_HOURS * SECONDS_IN_AN_HOUR;
export const intervalTypes = ['AUX', 'CAL', 'CNC', 'DSE', 'ESU', 'NCR', 'N/A'];
export const DATE_FORMAT = 'yyyy-MM-dd';
export const HIGHLIGHT_CLASSNAME = 'highlighted-field';
export const TITLE_PENDING_BACKLOG = 'Pending & Backlog';
export const EMPLOYEE_ID = 'user.employeeId';
export const MAX_3 = 3;
export const MAX_48 = 48;
export const MAX_2 = 2;
export const MAX_4 = 4;
export const MAX_6 = 6;
export const MAX_15 = 15;
export const MAX_50 = 50;
export const MAX_80 = 80;
export const MAX_1 = 1;
export const SECURITY_LEVEL = 3;
export const DEFAULT_NOTIFICATION_TEXT_SIZE = 80;
export const LOCATION_TYPES = [{
  label: 'A',
  value: 'A'
}, {
  label: 'S',
  value: 'S'
}, {
  label: 'U',
  value: 'U'
}];
export const Icons: {
  [key: string]: () => JSX.Element;
} = {
  customer: () => <Image priority src="/images/customer.svg" alt="Customer Icon" width={70} height={70} className="md:max-h-[50px]" />,
  freight: () => <Image priority src="/images/freight.svg" alt="Freight Icon" width={70} height={70} className="md:max-h-[50px]" />,
  partsAccys: () => <Image priority src="/images/parts_accy_icon.svg" alt="partsAccys Icon" width={70} height={70} className="md:max-h-[50px]" />,
  asset: () => <Image priority src="/images/asset.svg" alt="Asset Icon" width={70} height={70} className="md:max-h-[50px]" />,
  contactNew: () => <Image priority src="/images/contact-new.svg" alt="Asset Icon" width={70} height={70} className="md:max-h-[50px]" />,
  user: () => <Image priority src="/images/users-role.svg" alt="User Icon" width={70} height={70} className="max-h-[50px]" />,
  manufacturer: () => <Image priority src="/images/rental_agreement _new.svg" alt="Manufacturer Icon" width={70} height={70} className="max-h-[50px]" />,
  play_media: () => <Image priority src="/images/sales_start.svg" alt="Sales Start" width={70} height={70} className="max-h-[50px]" />,
  ft: () => <Image priority src="/images/fasttrack-new.svg" alt="FT Icon" width={70} height={70} className="max-h-[50px]" />,
  contact: () => <Image priority src="/images/contact.svg" alt="Contact Icon" width={70} height={70} className="max-h-[50px]" />,
  po: () => <Image priority src="/images/po_new.svg" alt="Pofile Icon" width={70} height={70} className="max-h-[50px]" />,
  pr: () => <Image priority src="/images/pr_new.svg" alt="Prfile Icon" width={70} height={70} className="max-h-[50px]" />,
  setting: () => <Image priority src="/images/manufacturer-model.svg" alt="Setting Icon" width={70} height={70} className="max-h-[50px]" />,
  group: () => <Image priority src="/images/group.svg" alt="Group Icon" width={70} height={70} className="max-h-[50px]" />,
  business: () => <Image priority src="/images/business.svg" alt="Bussiness Icon" width={70} height={70} className="max-h-[50px]" />,
  hotline: () => <Image priority src="/images/hotline.svg" alt="hotline Icon" width={70} height={70} className="max-h-[50px]" />,
  assetinfo: () => <Image priority src="/images/asset_info.svg" alt="Asset Information" width={70} height={70} className="max-h-[50px]" />,
  pendingtransaction: () => <Image priority src="/images/pendingtransaction.svg" alt="Pending Transactions" width={70} height={70} className="max-h-[50px]" />,
  pendingbacklogIcon: () => <Image priority src="/images/pendingbacklog.svg" alt="Backlog" width={70} height={70} className="max-h-[50px]" />,
  lab: () => <Image priority src="/images/lab_icon.svg" alt="Lab" width={70} height={70} className="max-h-[50px]" />,
  movementcontrol: () => <Image priority src="/images/movementcontrol_icon.svg" alt="Lab" width={70} height={70} className="max-h-[50px]" />,
  receivingIcon: () => <Image priority src="/images/receiving-icon.svg" alt="Lab" width={70} height={70} className="max-h-[50px]" />,
  packingIcon: () => <Image priority src="/images/packing-icon.svg" alt="Lab" width={70} height={70} className="max-h-[50px]" />,
  oscarIcon: () => <Image priority src="/images/oscar-icon.svg" alt="Lab" width={70} height={70} className="max-h-[50px]" />
};
export const mainMenuItems = {
  playMedia: {
    name: 'Sales Start',
    icon: Icons.play_media,
    module: 'startPage',
    key: 'start_page'
  },
  customer: {
    name: 'Customer',
    icon: Icons.customer,
    module: 'customer',
    key: 'customer_information'
  },
  asset: {
    name: 'Contact',
    icon: Icons.contactNew,
    module: 'contact',
    key: 'contacts'
  },
  manufacturer: {
    name: 'Rental Agreement',
    icon: Icons.manufacturer,
    module: 'rentalAgreement',
    key: 'rental_agreement'
  },
  ft: {
    name: 'Fast Track',
    icon: Icons.ft,
    module: 'frmFastTrack',
    key: 'fast_track'
  },
  usercontact: {
    name: 'Hotline',
    icon: Icons.hotline,
    module: 'hotline',
    key: 'hotline'
  },
  prfile: {
    name: 'Purchase Request',
    icon: Icons.pr,
    module: 'purchaseRequest',
    key: 'purchase_request'
  },
  pofile: {
    name: 'Purchase Order',
    icon: Icons.po,
    module: 'poView',
    key: 'po_view'
  },
  setting: {
    name: 'Manufacturer Model',
    icon: Icons.setting,
    module: 'manufacturer',
    key: 'manufacturer_model'
  },
  assetinformation: {
    name: 'Asset Information',
    icon: Icons.assetinfo,
    module: 'asset',
    key: 'asset'
  },
  pendingtransaction: {
    name: 'Pending Transactions',
    icon: Icons.pendingtransaction,
    module: 'credit',
    key: 'pending_credit'
  },
  pendingtbacklog: {
    name: 'Backlog',
    icon: Icons.pendingbacklogIcon,
    module: 'pendingBacklog',
    key: 'pending_and_backlog'
  },
  lab: {
    name: 'Lab',
    icon: Icons.lab,
    module: 'labFunction',
    key: 'lab_functions'
  },
  movementcontrol: {
    name: 'Movement & Control',
    icon: Icons.movementcontrol,
    module: 'movementControl',
    key: 'movement_and_control'
  },
  receiving: {
    name: 'Receiving',
    icon: Icons.receivingIcon,
    module: 'receiving',
    key: 'assets_accessories_receiving'
  },
  packingmenu: {
    name: 'Packing',
    icon: Icons.packingIcon,
    module: 'packing',
    key: 'packing'
  },
  freight: {
    name: 'Freight',
    icon: Icons.freight,
    module: 'freight',
    key: 'freight'
  },
  partsAccys: {
    name: 'Parts & Accessories',
    icon: Icons.partsAccys,
    module: 'partsAccys',
    key: 'part_accessories'
  },
  oscarmenu: {
    name: 'OSCD',
    icon: Icons.oscarIcon,
    module: 'oscar',
    key: 'oscar'
  },
  user: {
    name: 'Users Management',
    icon: Icons.user,
    module: 'userRoleSetup',
    key: 'userRoleSetup'
  }
  // group: {
  //   name: 'Group',
  //   icon: Icons.group,
  //   module: 'group',
  //   key: '',
  // },
  // business: {
  //   name: 'Business',
  //   icon: Icons.business,
  //   module: 'business',
  //   key: '',
  // },
};
export const menuItems: MenuItem[] = [{
  title: 'File',
  submenu: [{
    title: 'Home',
    windowTitle: 'Home',
    module: 'home',
    key: ''
  }, {
    title: 'Request Tracking',
    windowTitle: 'Request Tracking',
    module: 'requestTracking',
    key: 'request_tracking'
  }, {
    title: 'Exit',
    windowTitle: 'Exit',
    module: '',
    key: ''
  }]
}, {
  title: 'Customers',
  submenu: [{
    title: 'Start Page',
    windowTitle: 'Start Page',
    module: 'startPage',
    key: 'start_page'
  }, {
    title: 'Contacts',
    windowTitle: 'Contacts',
    module: 'contact',
    key: 'contacts'
  }, {
    title: 'Information',
    windowTitle: 'Customer',
    module: 'customer',
    key: 'customer_information'
  }, {
    title: 'Invoice Scan',
    windowTitle: 'Customer Invoice Scan',
    module: 'invoiceScan',
    key: 'customer_invoice_scan'
  }, {
    title: 'Exposure',
    windowTitle: 'Customer - Exposure ',
    module: 'exposure',
    key: 'customer_exposure'
  }, {
    title: 'Bad Debt Write Off',
    windowTitle: 'Bad Debt Write Off',
    module: 'badDebtWriteOff',
    key: 'bad_debt_write_off'
  }]
}, {
  title: 'Sales',
  submenu: [{
    title: 'Customer Information',
    windowTitle: 'Customer',
    module: 'customer',
    key: 'customer_information'
  }, {
    title: TITLE_PENDING_BACKLOG,
    windowTitle: TITLE_PENDING_BACKLOG,
    module: 'pendingBacklog',
    key: 'pending_and_backlog'
  }, {
    title: 'Rental Agreement',
    windowTitle: 'Rental Agreement',
    module: 'rentalAgreement',
    key: 'rental_agreement'
  },
  // STAR-2273 - remove rent convert and reserve unreserve menu items
  // {
  //   title: 'Rental Conversion',
  //   windowTitle: 'Rental Conversion',
  //   module: 'rentalConversion',
  //   key: 'rental_conversion',
  // },
  // {
  //   title: 'Reserve/Unreserve Assets',
  //   windowTitle: 'Reserve/Unreserve Assets',
  //   module: 'reserveUnreserveAsset',
  //   key: 'reserve_unreserve_assets',
  // },
  {
    title: 'Lost Model Entry',
    windowTitle: 'New or Unavailable Model Information',
    module: 'modelInformation',
    key: 'new_or_unavailable_model_information'
  }, {
    title: 'Fast Track',
    windowTitle: 'Fast Track',
    module: 'frmFastTrack',
    key: 'fast_track'
  }, {
    title: 'Price Change Request',
    windowTitle: 'Price Change Request',
    module: 'priceChangeRequest',
    key: 'price_change_request'
  }]
}, {
  title: 'Transactions',
  submenu: [{
    title: 'Credit',
    windowTitle: 'Pending Credit, Price & Bad Debt Write Off and Order Verification',
    module: 'credit',
    key: 'credit_approval',
    winData: {
      tabName: 'creditApproval'
    }
  }, {
    title: 'Price Approval',
    windowTitle: 'Pending Credit, Price & Bad Debt Write Off and Order Verification',
    module: 'credit',
    key: 'price_approval',
    winData: {
      tabName: 'priceApproval'
    }
  }, {
    title: 'Bad Debt W/O',
    windowTitle: 'Pending Credit, Price & Bad Debt Write Off and Order Verification',
    module: 'credit',
    key: 'bad_debt_write_off',
    winData: {
      tabName: 'badDebtWriteOff'
    }
  }, {
    title: 'Order Verification',
    windowTitle: 'Pending Credit, Price & Bad Debt Write Off and Order Verification',
    module: 'credit',
    key: 'pending_credit',
    winData: {
      tabName: 'orderVerification'
    }
  }, {
    title: 'BuyOut Quote Approval',
    windowTitle: 'Pending Credit, Price & Bad Debt Write Off and Order Verification',
    module: 'credit',
    key: 'buyout_quote_approval',
    winData: {
      tabName: 'buyoutQuote'
    }
  }, {
    title: 'Web Orders',
    windowTitle: 'Pending Credit, Price & Bad Debt Write Off and Order Verification',
    module: 'credit',
    key: 'web_orders',
    winData: {
      tabName: 'webOrders'
    }
  }, {
    title: 'Web RFQs',
    windowTitle: 'Pending Credit, Price & Bad Debt Write Off and Order Verification',
    module: 'credit',
    key: '',
    winData: {
      tabName: 'webRfqs'
    }
  }]
}, {
  title: 'Purchasing',
  submenu: [
  // { title: 'Blanket PO', windowTitle: 'Blanket PO', module: 'blanketPo' },
  {
    title: 'PO Create',
    windowTitle: 'PO Create',
    module: 'poCreate',
    key: 'create_purchase_order'
  }, {
    title: 'PO View',
    windowTitle: 'Purchase Order',
    module: 'poView',
    key: 'po_view'
  }, {
    title: 'Purchase Request',
    windowTitle: 'Purchase Request',
    module: 'purchaseRequest',
    key: 'purchase_request'
  }, {
    title: 'Vendor',
    windowTitle: 'Vendor',
    module: 'vendor',
    key: 'vendor'
  }]
}, {
  title: 'Equipment',
  submenu: [{
    title: 'Asset Info',
    windowTitle: 'Asset',
    module: 'asset',
    key: 'asset'
  }, {
    title: 'Asset Ownership',
    windowTitle: 'Asset Ownership',
    module: 'assetOwnership',
    key: 'asset_ownership'
  }, {
    title: 'Group & Config',
    windowTitle: 'Group & Config',
    module: 'groupConfig',
    key: 'group_&_config'
  }, {
    title: 'Manf Model',
    windowTitle: 'Manufacturer Model',
    module: 'manufacturer',
    key: 'manufacturer_model'
  },
  // as per client request
  // {
  //   title: 'Pending Manf Model',
  //   windowTitle: 'Pending Manf Model',
  //   module: 'pendingManfModel',
  //   key: 'pending_manufacturer_model',
  // },
  {
    title: 'Merge & Link',
    windowTitle: 'Merge & Link',
    module: 'assetMergeAndLink',
    key: 'merge_and_link'
  }, {
    title: 'Asset Margin',
    windowTitle: 'Asset Margin',
    module: 'assetMargin',
    key: 'asset_margin'
  }, {
    title: 'Parts/Accys',
    windowTitle: 'Parts/Accys',
    module: 'partsAccys',
    key: 'part_accessories'
  }, {
    title: 'Accys Photo',
    windowTitle: 'Accessory Photos',
    module: 'accysPhoto',
    key: 'accessory_photos'
  }]
}, {
  title: 'Lab',
  submenu: [{
    title: 'Order Processing',
    windowTitle: 'Order Processing - LAB',
    module: 'raPullAsset',
    winData: {
      formType: 'LAB'
    },
    key: 'order_processing_lab'
  }, {
    title: 'Lab Functions',
    windowTitle: 'Lab Functions',
    module: 'labFunction',
    key: 'lab_functions'
  }, {
    title: 'Asset Accys',
    windowTitle: 'Accessories',
    module: 'assetAccys',
    key: 'accessories'
  }, {
    title: TITLE_PENDING_BACKLOG,
    windowTitle: TITLE_PENDING_BACKLOG,
    module: 'pendingBacklog',
    key: 'pending_and_backlog'
  }, {
    title: 'Technical Library',
    windowTitle: 'Technical Library',
    module: 'technicalLibraryBrowseFacility',
    key: 'technical_library_browse_facility'
  }]
}, {
  title: 'Demo',
  submenu: [{
    title: 'Reserve Model',
    windowTitle: 'MR Requestor Sign-in',
    module: 'mrRequestorSignIn',
    key: 'mr_requestor_sign_in'
  }, {
    title: 'Rental Agreement',
    windowTitle: 'Rental Agreement',
    module: 'rentalAgreement',
    key: 'rental_agreement'
  }]
}, {
  title: 'Support',
  submenu: [{
    title: 'Billing Adj',
    module: 'billingAdjustment',
    windowTitle: 'Billing Adjustment',
    key: 'billing_adjustment'
  }, {
    title: 'Dairy',
    module: 'dairy',
    windowTitle: 'Dairy',
    key: 'dairy'
  }, {
    title: 'Hotline',
    module: 'hotline',
    windowTitle: 'Hotline',
    key: 'hotline'
  }, {
    title: 'Terminate',
    module: 'receiveAndTerminateScreen',
    windowTitle: 'Receive & Terminate Screen',
    key: 'terminate'
  }, {
    title: 'Unsell',
    module: 'unSellRequest',
    windowTitle: 'Unsell Request',
    key: 'unsell'
  }]
}, {
  title: 'Warehouse',
  submenu: [{
    title: 'Order Processing',
    windowTitle: 'Order Processing - Warehouse',
    module: 'raPullAssetWareHouse',
    winData: {
      formType: 'PUL'
    },
    key: 'order_processing_warehouse'
  }, {
    title: 'Receiving',
    windowTitle: 'Assets / Accessories Receiving',
    module: 'receiving',
    key: 'assets_accessories_receiving'
  }, {
    title: 'Accessorizing',
    windowTitle: 'Accessorizer',
    module: 'accessorizing',
    key: 'accessorizing'
  }, {
    title: 'Fill Requests',
    windowTitle: 'Parts - Fill Requests Form',
    module: 'fillRequests',
    key: 'parts_fill_requests_form'
  }, {
    title: 'RTA',
    windowTitle: 'RTA',
    module: 'rta',
    key: 'rta'
  }, {
    title: 'Freight Invoice',
    windowTitle: 'Add Freight Invoices',
    module: 'frightInvoice',
    key: 'add_freight_invoices'
  }, {
    title: 'Freight',
    windowTitle: 'Freight',
    module: 'freight',
    key: 'freight'
  }, {
    title: 'Movement & Control',
    windowTitle: 'Movement & Control',
    module: 'movementControl',
    key: 'movement_and_control'
  }, {
    title: 'Oscar',
    windowTitle: 'Outbound Shipment Control',
    module: 'oscar',
    key: 'oscar'
  }, {
    title: 'Packing',
    windowTitle: 'Packing',
    module: 'packing',
    key: 'packing'
  }, {
    title: TITLE_PENDING_BACKLOG,
    windowTitle: TITLE_PENDING_BACKLOG,
    module: 'pendingBacklog',
    key: 'pending_and_backlog'
  }, {
    title: 'Enter Waybill',
    windowTitle: 'Waybill Entry form',
    module: 'enterWaybill',
    key: 'waybill_entry_form'
  }, {
    title: 'Labels',
    windowTitle: 'Labels',
    module: 'labels',
    key: 'labels'
  }]
}, {
  title: 'Help',
  submenu: [{
    title: 'Change Password',
    windowTitle: 'Change Password',
    module: '',
    key: ''
  }, {
    title: 'Reset Password',
    windowTitle: 'Reset Password',
    module: '',
    key: ''
  }, {
    title: 'Contents',
    windowTitle: 'Contents',
    module: '',
    key: ''
  }, {
    title: 'Search For Help On...',
    windowTitle: 'Search For Help On...',
    module: '',
    key: ''
  }, {
    title: 'How To Use Help',
    windowTitle: 'How To Use Help',
    module: '',
    key: ''
  }, {
    title: 'About STAR for Windows',
    windowTitle: 'About NexStar',
    module: 'about',
    key: ''
  }]
}, {
  title: 'SubForms',
  submenu: [{
    title: 'Custom Dropdown Demo',
    windowTitle: 'Custom Dropdown Demo',
    module: 'exampleDualDropdown',
    key: ''
  }, {
    title: 'Custom Infinite Scroll Table Demo',
    windowTitle: 'Custom Infinite Scroll Table Demo',
    module: 'exampleInfiniteScrollTable',
    key: ''
  }, {
    title: 'Credit card prefill',
    windowTitle: 'Credit card prefill',
    module: 'creditCardPrefill',
    key: '',
    winData: {
      raNumber: '1902950',
      customerId: '123'
    }
  }]
}, {
  title: 'Admin Forms',
  submenu: [{
    title: 'Users',
    windowTitle: 'Users',
    module: 'users',
    key: 'users'
  }, {
    title: 'Version Control',
    windowTitle: 'Version Control',
    module: 'version',
    key: 'nex_star_version_history_management'
  }, {
    title: 'Credit Cards - Wells fargo',
    windowTitle: 'Credit Cards - Wells fargo',
    module: 'ccProcess',
    key: 'cc_process'
  }, {
    title: 'Auto Order Approval Limits',
    windowTitle: ' Auto Order Approval Criteria',
    module: 'orderApprovalLimits',
    key: 'order_approval_limits'
  }, {
    title: 'Technical Library Maintenance',
    windowTitle: 'Technical Library Maintenance',
    module: 'technicalLibraryMaintenance',
    key: 'tech_library'
  }, {
    title: 'Dim Weight',
    windowTitle: 'Dim Weight',
    module: 'dimWeight',
    key: 'dim_weight'
  }, {
    title: 'MR User',
    windowTitle: 'MR User',
    module: 'mrUser',
    key: 'mr_user'
  }, {
    title: 'Tax Certificates Information',
    windowTitle: 'Tax Certificates Information',
    module: 'taxCertificatesInformation',
    key: 'tax_certificates'
  }, {
    title: 'Location Codes',
    windowTitle: 'Location Codes',
    module: 'locationCodes',
    key: 'location-codes'
  }, {
    title: 'Time Worked Maintenance',
    windowTitle: 'Time Worked Maintenance',
    module: 'timeWorkedMaintenance',
    key: 'time_worked'
  }, {
    title: 'MR Manufacturer Model Information',
    windowTitle: 'MR Manufacturer Model Information',
    module: 'manufacturerModelInformation',
    key: 'mr_mfg_mdl_info'
  }, {
    title: 'Lab Standards',
    windowTitle: 'Lab Standards',
    module: 'nistLabStandards',
    key: 'lab_standards'
  }, {
    title: 'Temperature And Humidity',
    windowTitle: 'Temperature And Humidity',
    module: 'temperatureAndHumidity',
    key: 'temp_and_humidity'
  }, {
    title: 'Lost Reason',
    windowTitle: 'Lost Reason Codes',
    module: 'lostReasonsCodes',
    key: 'lost_reason_code'
  }, {
    title: 'Gl Accounts and Reasons',
    windowTitle: 'Gl Accounts and Reasons',
    module: 'Frmglar',
    key: 'gl_accounts_reasons'
  }, {
    title: 'Customer Hold Exception',
    windowTitle: 'Customer Hold Exception',
    module: 'customerHoldExclusion',
    key: 'customer_hold_exclusion'
  }, {
    title: 'Price Approval',
    windowTitle: 'Price Approval',
    module: 'priceApproval',
    key: 'price_approval'
  }, {
    title: 'Territories',
    windowTitle: 'Territories',
    module: 'territory',
    key: 'territory'
  }, {
    title: 'ACH Process',
    windowTitle: 'ACH Process',
    module: 'achProcess',
    key: 'ach_process'
  }, {
    title: 'Region Codes',
    windowTitle: 'Region Codes',
    module: 'regionCodes',
    key: 'region_codes'
  }, {
    title: 'Equipment Codes',
    windowTitle: 'Equipment Codes',
    module: 'equipmentCodes',
    key: 'e_code'
  }, {
    title: 'MPS Advanced Codes',
    windowTitle: 'MPS Advanced Codes',
    module: 'mpsAdvancedCodes',
    key: 'mps_advanced_codes'
  }, {
    title: 'Equipment Products',
    windowTitle: 'Equipment Products',
    module: 'equipmentProducts',
    key: 'ep_code'
  }, {
    title: 'Freight Rates',
    windowTitle: 'Freight Rates',
    module: 'freightRates',
    key: 'frt_rates'
  }, {
    title: 'Model Substitutes',
    windowTitle: 'Model Substitutes',
    module: 'modelSubstitutes',
    key: 'model_substitutes'
  }, {
    title: 'Auto Email Maintenance',
    windowTitle: 'Auto Email Maintenance',
    module: 'autoEmailMaintenance',
    key: 'auto_email'
  }, {
    title: 'Price Floor',
    windowTitle: 'MPS Price Floor',
    module: 'mpsPriceFloor',
    key: 'mps_price_floor'
  }, {
    title: 'MPS Base Rates',
    windowTitle: 'MPS Base Rates',
    module: 'mpsBaseRates',
    key: 'mps_base_rate'
  }, {
    title: 'Comment Captions',
    windowTitle: 'Ra Component-Asset Comment Captions',
    module: 'commentCaptions',
    key: 'cmt_cap'
  }, {
    title: 'Customs Broker',
    windowTitle: 'Customs Broker',
    module: 'customsBroker',
    key: 'broker'
  }, {
    title: 'Asset Group',
    windowTitle: 'Asset Group',
    module: 'assetGroup',
    key: 'asset_group'
  }, {
    title: 'Credit Approval Limits',
    windowTitle: 'Credit Line Approval',
    module: 'creditLineApproval',
    key: 'credit_approval_limits'
  }]
}];
export const windowSizes: Record<string, {
  size?: {
    height?: number;
    width?: number;
  };
  isAdjustable?: boolean;
  winData?: WinDataType;
  disableOtherInteractions?: boolean;
}> = {
  vendorPurchaseOrder: {
    size: {
      height: 794
    },
    isAdjustable: true
  },
  purchaseRequest: {
    size: {
      width: 1030,
      height: 904
    },
    isAdjustable: true
  },
  raDtlChangeRADetailData: {
    size: {
      height: 400,
      width: 600
    },
    isAdjustable: false
  },
  raList: {
    size: {
      height: 550,
      width: 450
    },
    isAdjustable: false
  },
  compareTaxStat: {
    size: {
      height: 160,
      width: 500
    },
    isAdjustable: false
  },
  invoiceAndDeliveryLevels: {
    size: {
      height: 690
    },
    isAdjustable: true
  },
  customerInformation: {
    size: {
      height: 905,
      width: 1220
    },
    isAdjustable: true
  },
  poView: {
    size: {
      width: 1030,
      height: 904
    },
    isAdjustable: true
  },
  vendor: {
    size: {
      width: 1000
    },
    isAdjustable: true
  },
  rentalAgreement: {
    size: {
      width: 1200
    },
    isAdjustable: true
  },
  creditCardPrefill: {
    size: {
      height: 500,
      width: 500
    },
    isAdjustable: true
  },
  modelInformation: {
    size: {
      height: 770,
      width: 840
    },
    isAdjustable: true
  },
  bdwoSignoff: {
    size: {
      width: 400,
      height: 180
    },
    isAdjustable: false
  },
  mrRequestorSignIn: {
    size: {
      width: 600,
      height: 240
    }
  },
  accessoryPackage: {
    size: {
      height: 610,
      width: 1130
    }
  },
  selectProcedure: {
    size: {
      height: 200,
      width: 400
    },
    isAdjustable: false
  },
  avlInspection: {
    size: {
      height: 450,
      width: 320
    },
    isAdjustable: false
  },
  poDetails: {
    size: {
      height: 385,
      width: 400
    },
    isAdjustable: false
  },
  poPrintConfirmation: {
    size: {
      height: 220,
      width: 450
    },
    isAdjustable: false
  },
  partsOrAccessoriesReceiving: {
    size: {
      height: 210,
      width: 300
    },
    isAdjustable: false
  },
  eSignPOView: {
    size: {
      height: 150,
      width: 550
    },
    isAdjustable: false
  },
  ReceivePrint: {
    size: {
      height: 190,
      width: 550
    },
    isAdjustable: true
  },
  changeWaybillNumber: {
    size: {
      height: 220,
      width: 700
    },
    isAdjustable: false
  },
  VerifyPartRequest: {
    size: {
      height: 350,
      width: 500
    },
    isAdjustable: false
  },
  frmRtaNew: {
    size: {
      height: 300,
      width: 400
    },
    isAdjustable: false
  },
  verifyPurchaseRequest: {
    size: {
      height: 400,
      width: 600
    },
    isAdjustable: false
  },
  verifyModelDataForQuote: {
    size: {
      height: 400,
      width: 600
    },
    isAdjustable: true
  },
  scanDairyByRa: {
    size: {
      height: 400,
      width: 700
    },
    isAdjustable: false
  },
  riskCode: {
    size: {
      height: 350,
      width: 500
    },
    isAdjustable: false
  },
  receiveAndTerminateScreen: {
    size: {
      height: 380,
      width: 840
    },
    isAdjustable: true
  },
  changePoLineData: {
    size: {
      height: 460,
      width: 700
    },
    isAdjustable: false
  },
  credit: {
    size: {
      height: 820,
      width: 1420
    },
    isAdjustable: true
  },
  receiving: {
    size: {
      width: 1500
    },
    isAdjustable: true
  },
  raAssetAccessories: {
    size: {
      width: 840,
      height: 651
    },
    isAdjustable: true
  },
  scanInAssets: {
    size: {
      height: 250,
      width: 450
    },
    isAdjustable: false
  },
  addAccessories: {
    size: {
      height: 220,
      width: 500
    },
    isAdjustable: false
  },
  selectPartsAccessoriesModal: {
    size: {
      height: 310,
      width: 700
    },
    isAdjustable: false
  },
  assetSearch: {
    size: {
      height: 400,
      width: 600
    },
    isAdjustable: false
  },
  partsAccessoriesVendorDetails: {
    isAdjustable: false
  },
  badDebtWriteOffApproval: {
    size: {
      height: 500,
      width: 700
    },
    isAdjustable: false,
    winData: {
      bDWOId: 661
    }
  },
  scanCustomer: {
    size: {
      height: 170,
      width: 400
    },
    isAdjustable: false
  },
  geoCodeAddressOptions: {
    size: {
      height: 500,
      width: 700
    },
    isAdjustable: true
  },
  affectedItems: {
    size: {
      width: 600,
      height: 420
    },
    isAdjustable: true,
    winData: {
      customerNum: 101063,
      orType: 'Addr',
      addressId: 2804
    }
  },
  mpsAdvanceUpdate: {
    size: {
      width: 700,
      height: 430
    },
    isAdjustable: false
  },
  roles: {
    size: {
      width: 1000,
      height: 430
    },
    isAdjustable: false
  },
  creditCardAuthorization: {
    size: {
      width: 580,
      height: 285
    },
    isAdjustable: true
  },
  customerComment: {
    size: {
      width: 700,
      height: 480
    },
    isAdjustable: false
  },
  rfpAssetList: {
    isAdjustable: true
  },
  buyoutQuoteApproval: {
    size: {
      width: 1534
    },
    isAdjustable: true
  },
  billAdjustInvoices: {
    size: {
      width: 500,
      height: 450
    },
    isAdjustable: true
  },
  viewNotification: {
    size: {
      width: 700,
      height: 460
    },
    isAdjustable: false
  },
  specialComments: {
    size: {
      height: 720,
      width: 600
    },
    isAdjustable: true
  },
  startPage: {
    size: {
      width: 1120
    },
    isAdjustable: true
  },
  raAssetExchange: {
    size: {
      height: 740,
      width: 920
    },
    isAdjustable: true
  },
  changeRaTransferDetailData: {
    size: {
      height: 200,
      width: 600
    },
    isAdjustable: false
  },
  taxRates: {
    size: {
      height: 651
    },
    isAdjustable: false,
    disableOtherInteractions: true
  },
  buyoutQuoteSignoff: {
    size: {
      height: 250,
      width: 450
    },
    isAdjustable: false
  },
  priceApprovalSignOff: {
    size: {
      height: 200,
      width: 420
    },
    isAdjustable: false
  },
  creditSignOff: {
    size: {
      height: 380,
      width: 450
    },
    isAdjustable: false
  },
  changeMfgModel: {
    size: {
      height: 300,
      width: 450
    },
    isAdjustable: true
  },
  raCompTransfer: {
    size: {
      height: 780
    },
    isAdjustable: true
  },
  pendingManfModel: {
    isAdjustable: true
  },
  fillRequests: {
    size: {
      width: 1320
    },
    isAdjustable: true
  },
  specialInstructions: {
    size: {
      height: 440,
      width: 700
    },
    isAdjustable: true
  },
  raLstLostComponent: {
    size: {
      height: 180,
      width: 400
    },
    isAdjustable: false
  },
  commitAsset: {
    size: {
      height: 250,
      width: 342
    },
    isAdjustable: false
  },
  moveTo: {
    size: {
      height: 280,
      width: 400
    },
    isAdjustable: false
  },
  webOrdersAndBadRFQ: {
    size: {
      width: 975
    },
    isAdjustable: true
  },
  hotlineSignOff: {
    size: {
      height: 180,
      width: 380
    },
    isAdjustable: true,
    winData: {
      hotlineId: '309532',
      assetId: '1304055'
    }
  },
  billingAdjustment: {
    size: {
      width: 1380
    },
    isAdjustable: true
  },
  requestTracking: {
    size: {
      height: 760,
      width: 1120
    },
    isAdjustable: true
  },
  updateManufacturer: {
    size: {
      height: 200,
      width: 600
    },
    isAdjustable: true
  },
  oscar: {
    size: {
      height: 870,
      width: 1000
    }
  },
  match: {
    size: {
      height: 400,
      width: 600
    },
    isAdjustable: false
  },
  priceApprovalDetails: {
    size: {
      height: 410,
      width: 600
    },
    isAdjustable: false
  },
  sortFields: {
    size: {
      height: 280,
      width: 400
    },
    isAdjustable: false
  },
  technicalLibraryMaintenance: {
    size: {
      height: 830,
      width: 1160
    }
  },
  mrUser: {
    size: {
      height: 925,
      width: 900
    }
  },
  taxCertificatesInformation: {
    size: {
      height: 760,
      width: 900
    }
  },
  nistLabStandards: {
    size: {
      height: 812,
      width: 960
    }
  },
  about: {
    size: {
      height: 330,
      width: 550
    },
    isAdjustable: false
  },
  frmFastTrack: {
    size: {
      height: 786,
      width: 1010
    }
  },
  contact: {
    size: {
      width: 1200
    }
  },
  hotline: {
    size: {
      width: 1660
    }
  },
  territory: {
    size: {
      height: 888,
      width: 1040
    }
  },
  duplicateAddress: {
    size: {
      width: 675,
      height: 676
    },
    isAdjustable: true
  },
  temperatureAndHumidity: {
    size: {
      height: 640
    },
    isAdjustable: true
  },
  manufacturerModelInformation: {
    size: {
      height: 615
    },
    isAdjustable: true
  },
  timeWorkedMaintenance: {
    size: {
      height: 545
    },
    isAdjustable: true
  },
  locationCodes: {
    size: {
      height: 580
    },
    isAdjustable: true
  },
  commentCaptions: {
    size: {
      height: 865,
      width: 1000
    },
    isAdjustable: true
  },
  customsBroker: {
    size: {
      height: 760,
      width: 900
    },
    isAdjustable: true
  },
  mpsPriceFloor: {
    size: {
      height: 520
    },
    isAdjustable: true
  },
  mpsBaseRates: {
    size: {
      height: 480
    },
    isAdjustable: true
  },
  invoiceEmailMaintenance: {
    size: {
      height: 612
    },
    isAdjustable: true
  },
  changePurchaseRequestData: {
    size: {
      height: 382
    },
    isAdjustable: true
  },
  labels: {
    size: {
      height: 600
    },
    isAdjustable: true
  },
  enterWaybill: {
    size: {
      height: 450
    },
    isAdjustable: true
  },
  pendingBacklog: {
    size: {
      width: 1620
    },
    isAdjustable: true
  },
  movementControl: {
    size: {
      height: 570
    },
    isAdjustable: true
  },
  frightInvoice: {
    size: {
      height: 630
    },
    isAdjustable: true
  },
  rta: {
    size: {
      height: 750,
      width: 1120
    },
    isAdjustable: true
  },
  raPullAssetWareHouse: {
    size: {
      height: 885,
      width: 1360
    },
    isAdjustable: true
  },
  unSellRequest: {
    size: {
      height: 455
    },
    isAdjustable: true
  },
  dairy: {
    size: {
      height: 652
    },
    isAdjustable: true
  },
  labFunction: {
    size: {
      height: 605
    },
    isAdjustable: true
  },
  assetAccys: {
    size: {
      height: 620
    },
    isAdjustable: true
  },
  accysPhoto: {
    size: {
      width: 1640
    },
    isAdjustable: true
  },
  assetMergeAndLink: {
    size: {
      height: 602
    },
    isAdjustable: true
  },
  assetOwnership: {
    size: {
      height: 670
    },
    isAdjustable: true
  },
  customer: {
    size: {
      height: 650,
      width: 1040
    },
    isAdjustable: true
  },
  reserveUnreserveAsset: {
    size: {
      height: 560
    },
    isAdjustable: true
  },
  invoiceScan: {
    size: {
      height: 710
    },
    isAdjustable: true
  },
  priceChangeRequest: {
    size: {
      width: 1200
    },
    isAdjustable: true
  },
  version: {
    size: {
      height: 435
    },
    isAdjustable: true
  },
  raPullAsset: {
    size: {
      height: 885,
      width: 1360
    },
    isAdjustable: true
  },
  accessoryStatus: {
    size: {
      height: 416
    },
    isAdjustable: true
  },
  modelReservation: {
    size: {
      height: 735
    },
    isAdjustable: true
  },
  priceApproval: {
    size: {
      height: 787
    },
    isAdjustable: true
  },
  matchData: {
    size: {
      height: 350,
      width: 600
    },
    isAdjustable: false
  },
  changeAssetStatus: {
    size: {
      height: 250,
      width: 400
    },
    isAdjustable: true
  },
  selectCompany: {
    size: {
      height: 230,
      width: 400
    },
    isAdjustable: true
  },
  home: {
    size: {
      width: 1300
    },
    isAdjustable: true
  },
  selectPrinter: {
    size: {
      height: 400,
      width: 900
    },
    isAdjustable: true
  },
  groupConfig: {
    size: {
      height: 735,
      width: 1400
    },
    isAdjustable: true
  },
  achProcess: {
    size: {
      height: 660
    },
    isAdjustable: true
  },
  equipmentProducts: {
    size: {
      height: 660
    },
    isAdjustable: true
  },
  freightRates: {
    size: {
      height: 700
    },
    isAdjustable: true
  },
  regionCodes: {
    size: {
      height: 530
    },
    isAdjustable: true
  },
  equipmentCodes: {
    size: {
      height: 570
    },
    isAdjustable: true
  },
  autoEmailMaintenance: {
    size: {
      height: 700
    },
    isAdjustable: true
  },
  users: {
    size: {
      height: 490
    },
    isAdjustable: true
  },
  customerAddress: {
    size: {
      width: 1150
    },
    isAdjustable: true
  },
  manufacturer: {
    size: {
      width: 1180
    },
    isAdjustable: true
  },
  viewCalCard: {
    size: {
      width: 1650
    },
    isAdjustable: true
  },
  editCalCard: {
    size: {
      width: 1650
    },
    isAdjustable: true
  },
  addCalCard: {
    size: {
      width: 1650
    },
    isAdjustable: true
  },
  creditApproval: {
    size: {
      width: 1350
    },
    isAdjustable: true
  },
  partsAccys: {
    size: {
      width: 1430
    },
    isAdjustable: true
  },
  packing: {
    size: {
      width: 1430,
      height: 800
    },
    isAdjustable: true
  },
  assetGroup: {
    size: {
      width: 700,
      height: 400
    },
    isAdjustable: true
  },
  poCreate: {
    size: {
      width: 1330,
      height: 754
    },
    isAdjustable: true
  },
  changeShipToComponent: {
    size: {
      width: 1140,
      height: 834
    },
    isAdjustable: true
  },
  addANewRepairOrder: {
    size: {
      width: 1000,
      height: 740
    },
    isAdjustable: true
  },
  reserveAssets: {
    size: {
      width: 1130
    },
    isAdjustable: true
  },
  raCreditCard: {
    size: {
      width: 850
    },
    isAdjustable: true
  },
  assignInvoiceEmailLevels: {
    size: {
      width: 1140
    },
    isAdjustable: true
  },
  creditLineApproval: {
    size: {
      width: 1250,
      height: 830
    },
    isAdjustable: true
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const commonReactSelectStyle: StylesConfig<any, boolean> = {
  container: base => ({
    ...base,
    width: '100%',
    minWidth: '150px'
  }),
  control: base => ({
    ...base,
    fontSize: '12px',
    minHeight: '30px'
  }),
  option: base => ({
    ...base,
    fontSize: '12px',
    minHeight: '30px',
    display: 'flex',
    alignItems: 'center'
  }),
  menu: base => ({
    ...base,
    minWidth: '100%',
    zIndex: 9999,
    // Ensure the dropdown appears on top
    // width: 'auto', // Adjust width automatically
    maxHeight: '200px',
    // Fixed height for the dropdown menu
    // overflowX: 'hidden', // Disable horizontal scrolling
    overflowY: 'auto',
    // Enable vertical scrolling
    touchAction: 'auto',
    pointerEvents: 'auto',
    scrollbarWidth: 'thin',
    // Thin scrollbar for better appearance
    '& *': {
      '& tr': {
        background: 'white'
      }
    },
    '&::-webkit-scrollbar': {
      width: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#ccc',
      borderRadius: '4px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#aaa'
    }
  }),
  menuList: base => ({
    ...base,
    maxHeight: '200px',
    // Fixed height for the menu list
    // overflowX: 'hidden', // Disable horizontal scrolling
    overflowY: 'auto',
    // Enable vertical scrolling
    touchAction: 'auto',
    pointerEvents: 'auto'
  })
};
export const dairyStatus = [{
  code: 'OPN',
  value: 'OPN',
  label: 'OPN',
  description: 'Open'
}, {
  code: 'NFD',
  value: 'NFD',
  label: 'NFD',
  description: 'Not Found'
}, {
  code: 'FND',
  value: 'FND',
  label: 'FND',
  description: 'Found'
}, {
  code: 'SEL',
  value: 'SEL',
  label: 'SEL',
  description: 'Sell'
}, {
  code: 'PLA',
  value: 'PLA',
  label: 'PLA',
  description: 'Possible Lost'
}, {
  code: 'CLS',
  value: 'CLS',
  label: 'CLS',
  description: 'Closed'
}, {
  code: 'NEW',
  value: 'NEW',
  label: 'New',
  description: 'New Dairy'
}];
export const reservationStatus = [{
  label: 'Long Term',
  value: 'Long Term'
}, {
  label: 'Normal',
  value: 'Normal'
}];
export const customerKaapAcct = [{
  code: '',
  division: ''
}, {
  code: 'E',
  division: 'Enviro.'
}, {
  code: 'R',
  division: 'RenTelco'
}, {
  code: 'B',
  division: 'Both'
}];
export const creditCardMonths = [{
  code: '01',
  month: 'January'
}, {
  code: '02',
  month: 'February'
}, {
  code: '03',
  month: 'March'
}, {
  code: '04',
  month: 'April'
}, {
  code: '05',
  month: 'May'
}, {
  code: '06',
  month: 'June'
}, {
  code: '07',
  month: 'July'
}, {
  code: '08',
  month: 'August'
}, {
  code: '09',
  month: 'September'
}, {
  code: '10',
  month: 'October'
}, {
  code: '11',
  month: 'November'
}, {
  code: '12',
  month: 'December'
}];
export const creditCardYears = (() => {
  // eslint-disable-next-line no-restricted-syntax
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i <= 10; i++) {
    const year = currentYear + i;
    years.push({
      code: year.toString(),
      year: year.toString()
    });
  }
  return years;
})();
export const creditAppFlag = [{
  value: 'Y',
  label: 'Y'
}, {
  value: 'N',
  label: 'N'
}];
export const dAndBClear = [{
  value: 'Y',
  label: 'Y'
}, {
  value: 'N',
  label: 'N'
}];
export const copyForm = [{
  value: 'weeks',
  label: 'weeks'
}, {
  value: 'months',
  label: 'months'
}, {
  value: 'days',
  label: 'days'
}];
export const addressTypes = {
  1: 'ST',
  2: 'BT',
  3: 'BT,ST',
  4: 'CC',
  5: 'ST,CC',
  6: 'BT,CC',
  7: 'ST,BT,CC'
};